var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerScrolling',{staticClass:"AccessibilityInformation"},[_c('LayoutFill',{attrs:{"no-gutters":!_vm.bannerGutter,"no-padding":!_vm.bannerGutter}},[_c('MainBanner',{attrs:{"title":_vm.pageTitle,"solid-header":_vm.solidHeader}})],1),_vm._v(" "),_c('LayoutGutters',[_c('LegalTerms',{attrs:{"term":"ACCESSIBILITY"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }